import * as React from 'react';
import { useShouldRenderBlueprint } from '../../../useShouldRenderBlueprint';
import VariantComponent from '../../../variant-component';
import BlueprintSubmitterGroup from './blueprint-submitter-group';
import BuieSubmitterGroup from './buie-submitter-group';

type Props = {
  components: React.ReactNode;
  description?: React.ReactNode;
  id: string;
  label?: React.ReactNode;
};

const SubmitterGroup = React.memo<Props>((props: Props) => {
  // Should be addressed in FORMS-21228
  const shouldRenderBlueprint = useShouldRenderBlueprint();

  return (
    <VariantComponent
      {...props}
      NewComponent={BlueprintSubmitterGroup}
      OldComponent={BuieSubmitterGroup}
      shouldRenderNewComponent={shouldRenderBlueprint}
    />
  );
});

export { SubmitterGroup };
export default SubmitterGroup;
